/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Event_Group_PromptInputs */

const en_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an Event Group from the top navbar`)
};

const fr_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un groupe d'evenements dans la barre de navigation superieure`)
};

const de_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Veranstaltungsgruppe aus der oberen Navigationsleiste aus.`)
};

const it_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un gruppo di eventi dalla barra di navigazione in alto`)
};

const ru_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите группу событий в верхней панели навигации.`)
};

const es_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un grupo de eventos en la barra de navegación superior`)
};

const zh_cn2_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从顶部导航栏选择一个活动组`)
};

const ja_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上部のナビゲーションバーからイベントグループを選択してください`)
};

const hi_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया शीर्ष नेविगेशन बार से एक इवेंट समूह चुनें।`)
};

const pt_pt2_editor_select_event_group_prompt = /** @type {(inputs: Editor_Select_Event_Group_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um Grupo de Eventos na barra de navegação superior.`)
};

/**
* | output |
* | --- |
* | "Please select an Event Group from the top navbar" |
*
* @param {Editor_Select_Event_Group_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_group_prompt = /** @type {((inputs?: Editor_Select_Event_Group_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_Group_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_event_group_prompt(inputs)
	if (locale === "de") return de_editor_select_event_group_prompt(inputs)
	if (locale === "it") return it_editor_select_event_group_prompt(inputs)
	if (locale === "ru") return ru_editor_select_event_group_prompt(inputs)
	if (locale === "es") return es_editor_select_event_group_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_event_group_prompt(inputs)
	if (locale === "ja") return ja_editor_select_event_group_prompt(inputs)
	if (locale === "hi") return hi_editor_select_event_group_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_event_group_prompt(inputs)
	return en_editor_select_event_group_prompt(inputs)
});